<div ng-controller="AppCtrl">
	
	<div class="shop-locator-loader" ng-show="showLoader"></div>
	
	<ui-view></ui-view>
</div>